import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export const WALLET_BALANCE_KEY = ['wallet', 'balance'] as const

/** `balance` is 0 while loading or on error (mobile WalletBloc fallback); use `isLoading` to tell them apart. */
export function useWalletBalance({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: WALLET_BALANCE_KEY,
    queryFn: async (): Promise<number> => {
      const res = await api.get('/wallet/balance')
      const balance = (res.data as { balance?: unknown } | undefined)?.balance
      return typeof balance === 'number' ? balance : 0
    },
    staleTime: 30_000,
    enabled,
  })
  return {
    balance: query.data ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  }
}
